import { ChangeDetectionStrategy, Component, Input, viewChild, input } from '@angular/core';
import { Popover, PopoverModule } from '@openng/optimus-ui/popover';
import { TooltipModule } from '@openng/optimus-ui/tooltip';

@Component({
  selector: 'ui-form-field-help',
  templateUrl: './form-field-help.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipModule, PopoverModule],
})
export class FormFieldHelpComponent {
  @Input()
  help: string | null = null;

  readonly extended = input(false);

  readonly tooltipPosition = input<'right' | 'left' | 'top' | 'bottom'>('left');

  readonly _overlayPanel = viewChild.required<Popover>('opRef');

  mouseOnOverlay = false;

  handleMouseLeave(timeoutMs = 500) {
    setTimeout(() => {
      const _overlayPanel = this._overlayPanel();
      if (_overlayPanel.overlayVisible && !this.mouseOnOverlay) _overlayPanel.hide();
    }, timeoutMs);
  }
}
